// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';
import { CloudIpAllocationWithRelationsSchema } from './CloudIpAllocationRelationsSchema'
import type { CloudIpAllocationWithRelations } from './CloudIpAllocationRelationsSchema'
import { ExternalNetworkCloudAccountPolicyWithRelationsSchema } from './ExternalNetworkCloudAccountPolicyRelationsSchema'
import type { ExternalNetworkCloudAccountPolicyWithRelations } from './ExternalNetworkCloudAccountPolicyRelationsSchema'
import { CloudInventoryAccountSchema } from './CloudInventoryAccountSchema';

/////////////////////////////////////////
// CLOUD INVENTORY ACCOUNT RELATION SCHEMA
/////////////////////////////////////////

export type CloudInventoryAccountRelations = {
  allocations: CloudIpAllocationWithRelations[];
  policies: ExternalNetworkCloudAccountPolicyWithRelations[];
};

export type CloudInventoryAccountWithRelations = z.infer<typeof CloudInventoryAccountSchema> & CloudInventoryAccountRelations

export const CloudInventoryAccountWithRelationsSchema: z.ZodType<CloudInventoryAccountWithRelations> = CloudInventoryAccountSchema.merge(z.object({
  allocations: z.lazy(() => CloudIpAllocationWithRelationsSchema).array(),
  policies: z.lazy(() => ExternalNetworkCloudAccountPolicyWithRelationsSchema).array(),
}))